/* eslint-disable react/prop-types */
import React, { useState } from "react";
import {
  Box,
  Button,
  FormControl,
  FormControlLabel,
  FormLabel,
  Modal,
  Radio,
  RadioGroup
} from "@mui/material";
import { styleForPourAndDispenseModal } from "./pour_and_dispense_utils";
import PourAndDispenseModalCloseIcon from "./pour_and_dispense_close_icon";

export const alcoholAmountOptions = [
  {
    label: "N/A",
    value: -1
  },
  {
    label: 0,
    value: 0
  },
  {
    label: 0.5,
    value: 0.5
  },
  {
    label: 1,
    value: 1
  },
  {
    label: 1.5,
    value: 1.5
  },
  {
    label: 2,
    value: 2
  },
  {
    label: 2.5,
    value: 2.5
  },
  {
    label: 3,
    value: 3
  },
  {
    label: 3.5,
    value: 3.5
  },
  {
    label: 4,
    value: 4
  },
  {
    label: 4.5,
    value: 4.5
  },
  {
    label: 5,
    value: 5
  },
  {
    label: 5.5,
    value: 5.5
  },
  {
    label: 6,
    value: 6
  },
  {
    label: 6.5,
    value: 6.5
  },
  {
    label: 7,
    value: 7
  },
  {
    label: 7.5,
    value: 7.5
  },
  {
    label: 8,
    value: 8
  },
  {
    label: 8.5,
    value: 8.5
  },
  {
    label: 9,
    value: 9
  },
  {
    label: 9.5,
    value: 9.5
  },
  {
    label: 10,
    value: 10
  }
];

const PourAndDispenseInputModal = ({ time, isOpen, onComplete, canDelete }) => {
  const [typeOfAlcohol, setTypeOfAlcohol] = useState(undefined);
  const [amountOfAlcohol, setAmountOfAlcohol] = useState(undefined);

  const resetSelections = () => {
    setTypeOfAlcohol(undefined);
    setAmountOfAlcohol(undefined);
  };

  const onCancel = () => {
    resetSelections();
    onComplete();
  };

  const onSave = () => {
    if (typeOfAlcohol === undefined || amountOfAlcohol === undefined) return;

    onComplete(typeOfAlcohol, amountOfAlcohol);
    resetSelections();
  };

  return (
    <Modal open={isOpen} onClose={onCancel} aria-labelledby="pour-entry-dialog-title">
      <Box className="ccw-dialog pour_and_dispense_dialog" sx={styleForPourAndDispenseModal}>
        <PourAndDispenseModalCloseIcon onClick={onCancel} />
        <header className="pour_and_dispense_dialog__header">
          <div>
            <p className="ccw-operations-eyebrow">Alcohol pour</p>
            <h2 id="pour-entry-dialog-title">Entry at {time}</h2>
          </div>
          {canDelete && (
            <Button
              className="ccw-button ccw-button--danger"
              onClick={() => onComplete(undefined, undefined, true)}
            >
              Delete entry
            </Button>
          )}
        </header>
        <div className="pour_and_dispense_modal pour_and_dispense_dialog__body">
          <div className="pour_and_dispense_modal_section">
            <FormControl className="pour_and_dispense_choice_group">
              <FormLabel>Type</FormLabel>
              <RadioGroup
                onChange={(event) => setTypeOfAlcohol(event.target.value)}
                value={typeOfAlcohol}
              >
                <FormControlLabel value="sherry" control={<Radio />} label="Sherry" />
                <FormControlLabel value="beer" control={<Radio />} label="Beer" />
                <FormControlLabel value="wine" control={<Radio />} label="Wine" />
                <FormControlLabel value="special_blend" control={<Radio />} label="Special blend" />
                <FormControlLabel value="hard_liquor" control={<Radio />} label="Hard liquor" />
                <FormControlLabel value="extra_special" control={<Radio />} label="Extra special" />
              </RadioGroup>
            </FormControl>
          </div>
          <div className="pour_and_dispense_modal_section">
            <FormControl className="pour_and_dispense_choice_group">
              <FormLabel>Amount</FormLabel>
              <RadioGroup
                className="pour_and_dispense_amount_grid"
                onChange={(event) => setAmountOfAlcohol(event.target.value)}
                value={amountOfAlcohol}
              >
                {alcoholAmountOptions.map((amount, index) => {
                  return (
                    <FormControlLabel
                      key={`alcoholAmountOptions ${index} ${amount.label}}`}
                      value={amount.value}
                      control={<Radio />}
                      label={amount.label + ""}
                    />
                  );
                })}
              </RadioGroup>
            </FormControl>
          </div>
        </div>
        <div className="pour_and_dispense_dialog__actions">
          <Button className="ccw-button" onClick={onCancel}>
            Cancel
          </Button>
          <Button
            className="ccw-button ccw-button--primary"
            disabled={typeOfAlcohol === undefined || amountOfAlcohol === undefined}
            onClick={onSave}
          >
            Save entry
          </Button>
        </div>
      </Box>
    </Modal>
  );
};

export default PourAndDispenseInputModal;
